@if (publication && publication.id ) {
  <h4 mat-dialog-title
  >{{ 'modulePublication.modal.titreModifier' | translate }}</h4>
}
@if (!(publication && publication.id) ) {
  <h4 mat-dialog-title
  >{{ 'modulePublication.modal.titreAjouter' | translate }}</h4>
}


@if (!saisieActivee) {
  <mat-dialog-content>
    <div id="choixSaisie">
      <div>
        <strong>{{'modulePublication.retrouvePublication'|translate}}</strong>
        <div id="pubMedFinder">
          <mat-form-field>
            <mat-label>PMID</mat-label>
            <input matInput [(ngModel)]="publication.pmid" strictNumberOnly maxlength="20">
          </mat-form-field>
          <div>
            <button mat-flat-button color="warn"
              (click)="searchOnPubMed()"
              [disabled]="isBusy || !(publication.pmid > 1000)">
              {{'general.recherche'|translate}}
            </button>
          </div>
        </div>
        @if (pmidList.includes(+publication.pmid)) {
          <div class="mt-1 alert alert-danger"
          >{{'modulePublication.pmidUnique'|translate}}</div>
        }
      </div>
      <div>
        <strong>{{'modulePublication.ajoutManuelTitre'|translate}}</strong>
        <p>{{'modulePublication.ajoutManuelDescription'|translate}}</p>
        <button mat-stroked-button
        (click)="saisieActivee=true;publication.pmid=null">{{'modulePublication.ajoutManuelBouton'|translate}}</button>
      </div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button color="warn" (click)="cancelModal()">{{ 'general.annuler' | translate }}</button>
  </mat-dialog-actions>
}


@if (saisieActivee && !publication.statut) {
  <mat-dialog-content>
    <form>
      <div class="form-group">
        <label for="statut">{{ 'modulePublication.modal.statut' | translate }}</label>
        <mat-select class="form-control" id="statut" name="statut" [(ngModel)]="publication.statut"
          #statut="ngModel" [required]="true">
          <mat-option [value]="1">{{'fields.formFieldPublicationList.statut-1'|translate}}</mat-option>
          <mat-option [value]="2">{{'fields.formFieldPublicationList.statut-2'|translate}}</mat-option>
          <mat-option [value]="3">{{'fields.formFieldPublicationList.statut-3'|translate}}</mat-option>
          @if (showStatutSoumis) {
            <mat-option [value]="4">
              {{'fields.formFieldPublicationList.statut-4'|translate}}
            </mat-option>
          }
          @if (showStatutEnPreparation) {
            <mat-option [value]="5">
              {{'fields.formFieldPublicationList.statut-5'|translate}}
            </mat-option>
          }
        </mat-select>
      </div>
    </form>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button color="warn" (click)="saisieActivee = false">{{ 'general.annuler' | translate }}</button>
  </mat-dialog-actions>
}


@if (saisieActivee && publication.statut) {
  <mat-dialog-content>
    <form #publicationForm="ngForm">
      <div class="flex-fields">
        <div class="field-statut form-group">
          <label for="statut">{{ 'modulePublication.modal.statut' | translate }}</label>
          <input type="text" class="form-control" [readonly]="true" [disabled]="true"
            value="{{ ('fields.formFieldPublicationList.statut-' + publication.statut)|translate}}">
          </div>
          <div class="field-type form-group">
            <label for="publicationType">
              {{ 'general.typePublication' | translate }}
              <span class="star">*</span>
            </label>
            <mat-select class="form-control" id="publicationType" name="publicationType"
              [(ngModel)]="publication.publicationType"
              #publicationType="ngModel" [required]="true"
              [compareWith]="toolService.compareByApiResource"
              >
              @for (type of publicationTypeList; track type) {
                <mat-option [value]="type['@id']">
                  {{generateFormControlService.getLabelForDynamicObject(type)}}
                </mat-option>
              }
            </mat-select>
          </div>
          @if (publication.statut === STATUT_PUBLIE) {
            <div class="field-pmid form-group">
              <label for="pmid">PMID :</label>
              <input type="number" name="pmid" class="form-control" id="pmid" [(ngModel)]="publication.pmid"
                strictNumberOnly>
                @if (publication.pmid && !matchNumber(publication.pmid)) {
                  <p
                    class="requiredMessage">{{'front.publication.pmidIncorrect'|translate}}
                  </p>
                }
                @if (isPmidUsed()) {
                  <p
                    class="requiredMessage">{{'modulePublication.pmidUnique'|translate}}
                  </p>
                }
              </div>
            }
            @if ([STATUT_PUBLIE, STATUT_SOUS_PRESSE, STATUT_REVISION].includes(publication.statut)) {
              <div class="field-doi form-group"
                >
                <label for="doi">DOI :</label>
                <input type="text" name="doi" class="form-control" id="doi"
                  [(ngModel)]="publication.doi" #doi="ngModel">
                </div>
              }
            </div>
            <div class="flex-fields">
              <div class="field-annee form-group">
                <label for="annee">
                  {{ 'modulePublication.modal.annee' | translate }}
                  @if (publication.statut === STATUT_PUBLIE) {
                    <span class="star">*</span>
                  }
                </label>
                <input type="number" min="1903" max="2099" step="1" name="annee" class="form-control"
                  id="annee"
                  #annee="ngModel"
                  myNumberOnly [(ngModel)]="publication.annee">
                  @if (publication.annee && (publication.annee < 1904 || publication.annee > 2099)) {
                    <p
                      class="requiredMessage">{{'front.publication.anneeIncorrecte'|translate}}
                    </p>
                  }
                </div>
                <div class="form-group">
                  <label for="Journal">{{ 'modulePublication.modal.journal' | translate }}
                    <span class="star">*</span>
                  </label>
                  <input type="text" name="Journal" class="form-control" id="Journal"
                    [(ngModel)]="publication.journal" #journal="ngModel" [required]="true">
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <div class="form-group">
                      <label for="Titre">{{ 'modulePublication.modal.titre' | translate }} <span
                      class="star">*</span></label>
                      <!--<input type="text" name="Titre" class="form-control" id="Titre" [(ngModel)]="publication.titre"
                      #titre="ngModel" [required]="true">-->
                      <textarea name="titre" class="form-control" id="Titre" [(ngModel)]="publication.titre" rows="2"
                      #titre="ngModel" [required]="true"></textarea>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <div class="form-group">
                      <label for="Auteurs">{{ 'modulePublication.modal.listeAuteurs' | translate }}<span
                      class="star">*</span></label>
                      <quill-editor
                        id="Auteurs"
                        class="form-control form-control-1"
                        [modules]="modules"
                        name="Auteurs"
                        [(ngModel)]="publication.auteurs"
                        [placeholder]="' '"
                        #auteurs="ngModel"
                        [styles]="{'height': '150px'}"
                        [required]="true"
                      ></quill-editor>
                      <div id="modal-pub-counter" class="quill-counter">0 {{modules['counter'].unit}}</div>
                    </div>
                  </div>
                </div>
                @if ([STATUT_SOUS_PRESSE, STATUT_REVISION].includes(publication.statut)) {
                  <div class="row">
                    <div class="col">
                      <label>
                        {{ 'modulePublication.modal.fichier' | translate }}
                        <span class="star">*</span>
                        {{ 'modulePublication.modal.pdfUniquement' | translate }}
                      </label>
                      <app-file-uploader [type]="'publication'" (RemoveAfterSave)="removeCurrentFile()"
                        [file]="publication.fichier" #uploader (AfterSave)="currentFiledSaved($event)"
                      (OnFileChange)="uploader.save()"></app-file-uploader>
                    </div>
                  </div>
                }
              </form>
            </mat-dialog-content>
            <mat-dialog-actions>
              <button mat-button color="warn" (click)="cancelModal()">{{ 'general.annuler' | translate }}</button>
              <button mat-raised-button color="primary"
                [disabled]="buttonDisabled(publicationForm)"
              (click)="save()"> {{ 'general.save' | translate }} </button>
            </mat-dialog-actions>
          }
